/** Max length per field (first name, last name). Keep in sync with server `profileNameLimits.js`. */
export const PROFILE_NAME_MAX_LENGTH = 50;
